import ApiService from "./api.service";
let main = "/getInfo";

export default {
  getList({ params }) {
    return ApiService.post(`${main}/listDutyTable`, params);
  },
  getListLawyer(dutyTableId, regionId) {
    return ApiService.post(
      `${main}/mapLawyerDutyTable?dutyTableId=${dutyTableId}&regionId=${regionId}`
    );
  },
  signDutyTable(dutyTableId, signedData) {
    return ApiService.post(
      `${main}/signDutyTable?dutyTableId=${dutyTableId}`,
      signedData
    );
  },
};
